import React from 'react';


export default () => (
    <form id="frmLogout" role="form">
        <h2>You are logged out!</h2>
    </form>
  );



// WEBPACK FOOTER //
// ./src/app/components/logout/index.jsx